import type { GameState } from "./types";

const BASE = (import.meta.env.VITE_CINDERWAKE_API_URL as string | undefined)?.replace(/\/$/, "");

export async function submitRunSnapshot(state: GameState, event: "save" | "victory" | "defeat"): Promise<void> {
  if (!BASE) return;
  try {
    await fetch(`${BASE}/v1/runs/snapshot`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        run_id: state.seed,
        event,
        class_id: state.classId,
        act: state.act,
        floor: state.floor,
        hp: state.hp,
        max_hp: state.maxHp,
        deck_size: state.deck.length,
        relic_count: state.relics.length,
        stats: state.stats,
      }),
      keepalive: true,
    });
  } catch {
    // The Cloudflare frontend remains fully playable while the local tunnel is offline.
  }
}
